import { Box, Typography } from "@mui/material";
import React from "react";
import { TText } from "../typography/TText";
import { between } from "../style/style";
export const ITitle = ({ title, subtitle, rightComponent, }) => {
    return (React.createElement(Box, { sx: Object.assign({}, between) },
        React.createElement(Box, { sx: { minWidth: 0, flex: 1 } },
            React.createElement(Typography, { variant: "body2", color: "textSecondary" }, title),
            subtitle &&
                (typeof subtitle === "string" ? (React.createElement(TText, { text: subtitle, variant: "body2", color: "textPrimary" })) : (subtitle))),
        rightComponent && React.createElement(Box, { sx: { flexShrink: 0 } }, rightComponent)));
};
